"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimelineClipName = void 0;

var react_1 = require("react");

var HIDDEN_NAMES = ['__WEBPACK_DEFAULT_EXPORT__'];

var getTimelineClipName = function getTimelineClipName(children) {
  var _a;

  var tree = (_a = react_1.Children.map(children, function (ch) {
    if (!(0, react_1.isValidElement)(ch)) {
      return null;
    } // Must be name, not ID


    var name = typeof ch.type !== 'string' && ch.type.name;

    if (name && !HIDDEN_NAMES.includes(name)) {
      return name;
    }

    if (ch.props.children) {
      var chName = (0, exports.getTimelineClipName)(ch.props.children);
      return chName;
    }

    return null;
  })) === null || _a === void 0 ? void 0 : _a.filter(Boolean);
  return (tree === null || tree === void 0 ? void 0 : tree.length) ? tree[0] : '';
};

exports.getTimelineClipName = getTimelineClipName;